import { useEffect, useState } from 'react';

const MOBILE_BREAKPOINT = 768;

/**
 * Detects if the device width is <= 768px.
 * Compatible with modern, older, and very old browsers.
 * Optimized for performance and compatible with Server Components.
 */
export const useIsMobile = (): boolean => {
  const [isMobile, setIsMobile] = useState<boolean>(false);

  useEffect(() => {
    if (typeof window !== 'undefined') {
      const checkMobile = () => {
        setIsMobile(window.innerWidth <= MOBILE_BREAKPOINT);
      };

      if (window.matchMedia) {
        const mediaQuery = window.matchMedia(`(max-width: ${MOBILE_BREAKPOINT}px)`);

        const handleMediaQueryChange = (event: MediaQueryListEvent | MediaQueryList) => {
          setIsMobile(event.matches);
        };

        setIsMobile(mediaQuery.matches);

        if (mediaQuery.addEventListener) {
          mediaQuery.addEventListener('change', handleMediaQueryChange);
        } else if (mediaQuery.addListener) {
          mediaQuery.addListener(handleMediaQueryChange);
        } else {
          window.addEventListener('resize', checkMobile);
        }

        return () => {
          if (mediaQuery.removeEventListener) {
            mediaQuery.removeEventListener('change', handleMediaQueryChange);
          } else if (mediaQuery.removeListener) {
            mediaQuery.removeListener(handleMediaQueryChange);
          } else {
            window.removeEventListener('resize', checkMobile);
          }
        };
      } else {
        checkMobile();
        window.addEventListener('resize', checkMobile);
        return () => window.removeEventListener('resize', checkMobile);
      }
    }
  }, []);

  return isMobile;
};
